import styles from './MoreOptions.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { ChevronIcon } from 'seek-style-guide/react';
import QualifiedLink from 'QualifiedLink/QualifiedLink';

const mapStateToProps = ({ search }) => ({
  query: search.query
});

@connect(mapStateToProps)
export default class MoreOptions extends Component {

  static propTypes = {
    query: PropTypes.object.isRequired
  };

  render() {
    const { query } = this.props;

    return (
      <div className={styles.root}>
        <QualifiedLink
          className={styles.link}
          path="/jobs"
          params={query}
          state={{ moreOptions: true }}
          data-automation="moreOptionsLink"
          rel="nofollow"
          analytics="search+more-options">
          <span className={styles.label}>
            <span className={styles.labelOutline} />
            More options
          </span>
          <ChevronIcon
            direction="down"
            svgClassName={styles.chevronSvg}
          />
        </QualifiedLink>
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Search/components/SearchBar/components/MoreOptions/MoreOptions.js
 **/